import React, { useEffect, useState } from "react";
import { Divider } from "@mui/material";
import Accordian from "../../../components/accordian/accordian";
import { PlannerTotalsStyled } from "./planner-totals.styles";
import TextInputField from "../../../components/form-fields/text-input-field/text-input-field";
import { Typography } from "@mui/material";
import DiscountFieldWithUnits from "./discount-field-with-units/discount-field-with-units";
import { getDiscountedValue } from "./planner-totals.utils";
import { formatNumber } from "../../../utils/utils";

const PlannerTotals = ({
  projectData,
  calculatedProjectTotal,
  serviceValue,
  plannerState,
  isGeneralUser,
  setPlannerState,
  handleSave,
  plannerServiceValue,
}) => {
  const {
    serviceDiscount,
    materialDiscount,
    serviceDiscountUnit,
    materialDiscountUnit,
  } = plannerState;

  const discountedServiceTotal = getDiscountedValue(
    plannerServiceValue,
    serviceDiscount,
    serviceDiscountUnit
  );

  const discountedMaterialTotal = getDiscountedValue(
    calculatedProjectTotal - plannerServiceValue,
    materialDiscount,
    materialDiscountUnit
  );

  const totalValue = discountedServiceTotal + discountedMaterialTotal;
  const [expanded, setExpanded] = useState([""]);

  return (
    <PlannerTotalsStyled isGeneralUser={isGeneralUser}>
      <Accordian
        name="totals"
        handleChange={setExpanded}
        expanded={expanded.includes("totals") ? "totals" : ""}
        heading={
          <>
            <Typography variant="h5">Totals</Typography>
            <Typography color="#fff" variant={"h5"}>
              $ {formatNumber(totalValue)}
            </Typography>
          </>
        }
        body={
          <div className="totals-body">
            <div className="content">
              <div className="fields">
                <div style={{ pointerEvents: "none" }}>
                  <TextInputField
                    value={formatNumber(plannerServiceValue)}
                    placeholder="Total"
                    label={"Services Total"}
                    InputProps={{
                      startAdornment: <div>$</div>,
                    }}
                  />
                </div>

                <DiscountFieldWithUnits
                  label={"Service Discount"}
                  value={serviceDiscount}
                  unit={serviceDiscountUnit}
                  handleValueChange={(e) => {
                    setPlannerState((prev) => ({
                      ...prev,
                      serviceDiscount: parseFloat(e),
                    }));
                  }}
                  onUnitChange={(val) => {
                    setPlannerState((prev) => ({
                      ...prev,
                      serviceDiscountUnit: val,
                    }));
                  }}
                />

                <div style={{ pointerEvents: "none" }}>
                  <TextInputField
                    value={formatNumber(discountedServiceTotal)}
                    placeholder="Total"
                    label={"Services Subtotal"}
                    InputProps={{
                      startAdornment: <div>$</div>,
                    }}
                  />
                </div>
              </div>

              <div className="divider">
                <Divider className="div-style" orientation="horizontal" />
              </div>

              <div className="fields">
                <div style={{ pointerEvents: "none" }}>
                  <TextInputField
                    value={formatNumber(
                      calculatedProjectTotal - plannerServiceValue
                    )}
                    label={"Materials Total"}
                    InputProps={{
                      startAdornment: <div>$</div>,
                    }}
                  />
                </div>

                <DiscountFieldWithUnits
                  label={"Materials Discount"}
                  value={materialDiscount}
                  unit={materialDiscountUnit}
                  handleValueChange={(e) => {
                    setPlannerState((prev) => ({
                      ...prev,
                      materialDiscount: parseFloat(e),
                    }));
                  }}
                  onUnitChange={(val) => {
                    setPlannerState((prev) => ({
                      ...prev,
                      materialDiscountUnit: val,
                    }));
                  }}
                />

                <div style={{ pointerEvents: "none" }}>
                  <TextInputField
                    value={
                      discountedMaterialTotal
                        ? formatNumber(discountedMaterialTotal.toFixed(2))
                        : 0
                    }
                    label={"Materials Subtotal"}
                    InputProps={{
                      startAdornment: <div>$</div>,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        }
        variant="purple"
        arrowPosition="right"
      />
    </PlannerTotalsStyled>
  );
};

export default PlannerTotals;
